export const executionsConstants = {
  UPDATE_EXECUTIONS: '[Execution] Update task execution',
  EXECUTION_AJAX_CALL: '[Execution] Ajax call',
  EXECUTION_AJAX_SUCCESS: '[Execution] Ajax success',
  EXECUTION_AJAX_FAILURE: '[Execution] Ajax error',
  REMOVE_EXECUTION: '[Execution] Remove',
  EXECUTION_RESET: '[Execution] Reset list'
}
